/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Features_Live_WritingInputs */

const en_features_live_writing = /** @type {(inputs: Features_Live_WritingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} is adding the next exercise`)
};

const pl_features_live_writing = /** @type {(inputs: Features_Live_WritingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} dopisuje kolejne ćwiczenie`)
};

/**
* | output |
* | --- |
* | "{name} is adding the next exercise" |
*
* @param {Features_Live_WritingInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_live_writing = /** @type {((inputs: Features_Live_WritingInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Live_WritingInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_live_writing(inputs)
	return en_features_live_writing(inputs)
});